import expertsCircle from "@/assets/authority-experts-circle.webp.asset.json";
import fgSociety from "@/assets/authority-fg-society.jpg.asset.json";
import authorityMagazine from "@/assets/authority-authority-magazine.webp.asset.json";
import huffpost from "@/assets/authority-huffpost.webp.asset.json";
import designrush from "@/assets/authority-designrush.webp.asset.json";

const badges = [
  { src: expertsCircle.url, alt: "Experts Circle Member", className: "h-10" },
  { src: fgSociety.url, alt: "FG Society Certified Marketer", className: "h-12" },
  { src: authorityMagazine.url, alt: "Featured in Authority Magazine", className: "h-7" },
  { src: huffpost.url, alt: "Featured in HuffPost", className: "h-5" },
  { src: designrush.url, alt: "Listed on DesignRush", className: "h-6" },
] as const;

export function AuthorityBadges({ className = "", label = "TRUSTED BY" }: { className?: string; label?: React.ReactNode }) {
  return (
    <div className={`mt-6 ${className}`}>
      <p className="text-xs font-semibold tracking-wider text-muted-foreground">
        {label}
      </p>
      <div className="mt-3 flex flex-nowrap items-center justify-between gap-3">
        {badges.map((badge) => (
          <img
            key={badge.alt}
            src={badge.src}
            alt={badge.alt}
            className={`${badge.className} w-auto max-w-[19%] object-contain opacity-90`}
            loading="lazy"
            decoding="async"
          />
        ))}
      </div>
    </div>
  );
}

export default AuthorityBadges;
